export var FeatureName;
(function (FeatureName) {
    FeatureName["Files"] = "Encrypted File Storage";
    FeatureName["Super"] = "Super notes";
})(FeatureName || (FeatureName = {}));
